<template>
  <div class="public-layout">
    <!-- Header with Logo -->
    <header class="header">
      <div class="header-content">
        <img src="@/assets/logo.png" alt="Prec8" class="header-logo" @click="goHome" />
        <nav class="header-nav">
          <button @click="goToHowItWorks" class="nav-link">How it works</button>
          <button @click="goToSignIn" class="nav-link">Sign In</button>
        </nav>
      </div>
    </header>

    <!-- Main Content -->
    <main class="main-content">
      <slot></slot>
    </main>

    <!-- Footer -->
    <Footer />
    <FeedbackButton />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import Footer from './Footer.vue'
import FeedbackButton from './FeedbackButton.vue'

@Options({
  components: {
    Footer,
    FeedbackButton
  },
})
export default class PublicLayout extends Vue {
  goHome() {
    this.$router.push("/");
  }

  goToHowItWorks() {
    this.$router.push("/how-it-works");
  }

  goToSignIn() {
    this.$router.push("/sign-in");
  }
}
</script>

<style scoped>
.public-layout {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  color: #1a1a1a;
  line-height: 1.5;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100vw;
  margin: 0;
  padding: 0;
}

.header {
  background: #ffffff;
  padding: 0rem 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  flex-shrink: 0;
  width: 100%;

  .header-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .header-logo {
    height: 100px;
    width: auto;
    object-fit: contain;
    cursor: pointer;
  }

  .header-nav {
    display: flex;
    gap: 1.5rem;
  }

  .nav-link {
    background: none;
    border: none;
    color: #666;
    font-size: 1rem;
    cursor: pointer;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    transition: background-color 0.2s ease, color 0.2s ease;

    &:hover {
      background: #f6f9fc;
      color: #1a1a1a;
    }
  }
}

.main-content {
  flex: 1;
  min-height: 0;
  width: 100%;
  margin: 0;
  padding: 0;
}

@media (max-width: 768px) {
  .header {
    padding: 1rem;
  }

  .header-logo {
    height: 80px;
  }
}
</style>

<style>
/* Global CSS reset to remove default margins and padding */
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

#app {
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
  min-height: 100vh;
  box-sizing: border-box;
}

* {
  box-sizing: border-box;
}
</style> 